import {makeReactContext} from 'lib/makeReactContext';

interface ReviewBadgeContextValue {
  setIsOpen: (isOpen: boolean) => void;
}

export function getReviewBadgeContextFallback(): ReviewBadgeContextValue {
  return {
    setIsOpen: (isOpen) => {},
  };
}

// Controls the open/close state of the review badge
export const ReviewBadgeContext = makeReactContext<ReviewBadgeContextValue>(
  getReviewBadgeContextFallback,
  'ReviewBadgeContext'
);
